import { render, staticRenderFns } from "./ToggleCompany.vue?vue&type=template&id=549f495c&scoped=true&"
import script from "./ToggleCompany.vue?vue&type=script&lang=js&"
export * from "./ToggleCompany.vue?vue&type=script&lang=js&"
import style0 from "./ToggleCompany.vue?vue&type=style&index=0&id=549f495c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f495c",
  null
  
)

export default component.exports